import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-charge.reducer';

export const PatientProcedureChargeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureChargeEntity = useAppSelector(state => state.patientProcedureCharge.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureChargeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.detail.title">PatientProcedureCharge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.id}</dd>
          <dt>
            <span id="performedDate">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.performedDate">Performed Date</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.performedDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.timestampEntry}</dd>
          <dt>
            <span id="fromDate">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.fromDate">From Date</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.fromDate}</dd>
          <dt>
            <span id="toDate">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.toDate">To Date</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.toDate}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{patientProcedureChargeEntity.discount}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.procedure">Procedure</Translate>
          </dt>
          <dd>{patientProcedureChargeEntity.procedure ? patientProcedureChargeEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.appliedCharge">Applied Charge</Translate>
          </dt>
          <dd>{patientProcedureChargeEntity.appliedCharge ? patientProcedureChargeEntity.appliedCharge.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureCharge.multiplierEntry">Multiplier Entry</Translate>
          </dt>
          <dd>{patientProcedureChargeEntity.multiplierEntry ? patientProcedureChargeEntity.multiplierEntry.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-charge" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-charge/${patientProcedureChargeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureChargeDetail;
